export var KBUTTON_CLASSES = {
  primary: ['tw-bg-primary-light-500 tw-text-neutral-light-100', 'dark:tw-bg-primary-dark-600'],
  inverse: ['tw-border-[0.2rem]', 'tw-bg-transparent tw-border-primary-light-500 tw-text-primary-light-500', 'dark:tw-border-primary-dark-400 dark:tw-text-primary-dark-400'],
  payment: 'tw-bg-success-400 tw-text-neutral-light-800',
  'payment-inverse': ['tw-border-[0.2rem]', 'tw-bg-transparent tw-border-success-500 tw-text-success-500', 'dark:tw-border-success-400 dark:tw-text-success-400'],
  deactivate: 'tw-bg-on-hold-500 tw-text-neutral-light-100',
  'deactivate-inverse': ['tw-border-[0.2rem]', 'tw-bg-transparent tw-border-on-hold-500 tw-text-on-hold-500', 'dark:tw-border-on-hold-300 dark:tw-text-on-hold-300'],
  "delete": ['tw-bg-alert-500 tw-text-neutral-light-100', 'dark:tw-bg-alert-400'],
  'delete-inverse': ['tw-border-[0.2rem]', 'tw-bg-transparent tw-border-alert-500 tw-text-alert-500', 'dark:tw-border-alert-300 dark:tw-text-alert-300']
};
export var KBTN_FILLED_SIZE = {
  xs: 'tw-btn-filled-xs',
  s: 'tw-btn-filled-s',
  m: 'tw-btn-filled-m',
  l: 'tw-btn-filled-l',
  xl: 'tw-btn-filled-xl'
};
export var KBORDERED_BTN_SIZE = {
  xs: 'tw-btn-bordered-xs',
  s: 'tw-btn-bordered-s',
  m: 'tw-btn-bordered-m',
  l: 'tw-btn-bordered-l',
  xl: 'tw-btn-bordered-xl'
};